import * as tslib_1 from "tslib";
import { SearchMaskGroupType, } from '../../globalTypes';
import { all as mergeAll } from 'deepmerge';
var UserOptionsCreator = /** @class */ (function () {
    function UserOptionsCreator() {
    }
    UserOptionsCreator.create = function (lturState, searchMaskGroupType, optionalOptions) {
        if (searchMaskGroupType === void 0) { searchMaskGroupType = SearchMaskGroupType.PACKAGE; }
        if (optionalOptions === void 0) { optionalOptions = null; }
        if (!lturState
            || !lturState.websiteState
            || !lturState.websiteState.searchMask.searchMaskBundle
            || !lturState.websiteState.searchMask.searchMaskBundle.groups[searchMaskGroupType]) {
            return {};
        }
        var inputGroup = lturState.websiteState.searchMask.searchMaskBundle.groups[searchMaskGroupType];
        if (inputGroup) {
            return Object.keys(inputGroup.inputs).reduce(function (accumulator, currentInputKey) {
                var inputOptions = (inputGroup && inputGroup.inputs[currentInputKey].coreOptions ? tslib_1.__assign({}, inputGroup.inputs[currentInputKey].coreOptions) : {});
                var optOptions = ((optionalOptions && optionalOptions.type === currentInputKey && optionalOptions.coreOptions) ? tslib_1.__assign({}, optionalOptions.coreOptions) : {});
                return mergeAll([accumulator, inputOptions, optOptions]);
            }, {});
        }
        return {};
    };
    return UserOptionsCreator;
}());
export { UserOptionsCreator };
export default UserOptionsCreator;
